module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/btn-stop@2x.png?1.0.17";